module.exports = __webpack_public_path__ + "media/backgrounds/wod_background3-43b1a3bb.png";